﻿import { BillSummaryViewModel } from './billSummary.viewmodel';
import * as Repositories from '../../repositories/repositories'
import * as Model from '../../models/models';
import * as _ from 'lodash';


export class BillSummaryGateway {

    private numberOfAttempts: number = 0;
    private paymentMethodsHaveChanged: boolean = false;
    private deferred;
    private maximumAttempts: number = 40;
    private delayDuration: number = 500;

    static $inject = ['$q', '$timeout', 'userRepository', 'policyholderRepository', 'billingStatementRepository', 'paymentRepository'];

    constructor(private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private userRepository: Repositories.UserRepository,
        private policyholderRepository: Repositories.PolicyholderRepository,
        private billingStatementRepository: Repositories.BillingStatementRepository,
        private paymentRepository: Repositories.PaymentRepository) {
    }


    public loadBillSummaryViewModel = (billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {

        return this.userRepository.getUserProfile()
            .then((userProfile: Model.IUserProfile): BillSummaryViewModel => {
                billSummaryViewModel.userProfile = userProfile;
                return billSummaryViewModel;
            })
            .then((billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {
                return this.setPolicyholder(billSummaryViewModel);
            })
            .then((billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {
                return this.setBillingStatement(billSummaryViewModel);
            })

            .then((billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {
                return this.setPaymentMethods(billSummaryViewModel);
            });
    }

    public setPaymentMethods = (billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {

        return this.$q.all([
            this.getCardPaymentMethods(billSummaryViewModel).then((cardPaymentMethods: Array<Model.ICardPaymentMethod>) => billSummaryViewModel.cardPaymentMethods = cardPaymentMethods),
            this.getEcheckPaymentMethods(billSummaryViewModel).then((eCheckPaymentMethods: Array<Model.IEcheckPaymentMethod>) => billSummaryViewModel.echeckPaymentMethods = eCheckPaymentMethods)
        ]).then(() => { return billSummaryViewModel });

    }

    private setPolicyholder = (billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {
        return this.policyholderRepository.getPolicyholdersByUserId(billSummaryViewModel.userProfile.id)
            .then((policyholder: Model.IPolicyholder) => {
                billSummaryViewModel.policyholder = policyholder;
                return billSummaryViewModel;
            });
    }

    private setBillingStatement = (billSummaryViewModel: BillSummaryViewModel): ng.IPromise<BillSummaryViewModel> => {

        return this.billingStatementRepository.getById(billSummaryViewModel.policyholder.id)
            .then((billingStatement: Model.IBillingStatement) => {
                billSummaryViewModel.billingStatement = billingStatement;
                return billSummaryViewModel;
            });
    }

    private getCardPaymentMethods = (billSummaryViewModel: BillSummaryViewModel): ng.IPromise<Array<Model.ICardPaymentMethod>> => {
        return this.paymentRepository.getCardPaymentMethods(billSummaryViewModel.policyholder.id)
            .then((cardPaymentMethods: Array<Model.ICardPaymentMethod>) => {
                return cardPaymentMethods;
            });
    }

    private getEcheckPaymentMethods = (billSummaryViewModel: BillSummaryViewModel): ng.IPromise<Array<Model.IEcheckPaymentMethod>> => {
        return this.paymentRepository.getEcheckPaymentMethods(billSummaryViewModel.policyholder.id)
            .then((echeckPaymentMethods: Array<Model.IEcheckPaymentMethod>) => {
                return echeckPaymentMethods;
            });
    }
}